import type { KeywordLandingPageQuery } from '../../types';
import type { MetaDataContext } from './types';

type Props = {
  data: KeywordLandingPageQuery;
};

export default (
  { data: { keywordLandingPage: data } }: Props,
  { market, t }: MetaDataContext
) => {
  const {
    url,
    categories: { nodes: categories },
    title,
    inSitemap,
    parentCategory,
  } = data;

  const canonical = market.domain + url;
  const noIndex = !inSitemap;
  const breadcrumb = parentCategory?.path;

  return {
    title: t('meta', 'keyword-landing-page.title', {
      keyword: title[0].toUpperCase() + title.slice(1),
    }),
    description: categories.length
      ? t('meta', 'keyword-landing-page.description', {
          keyword: title[0].toUpperCase() + title.slice(1),
          categories: categories.map(category => category?.name).join(' '),
        })
      : t('meta', 'keyword-landing-page.description-offers-only', {
          keyword: title[0].toUpperCase() + title.slice(1),
        }),
    canonical,
    noIndex,
    breadcrumb,
  };
};
